import { Injectable } from '@angular/core';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { Inspection, InspectionPlugin } from '../../../shared/models/index';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IndexedDbService } from '../../../shared/services/indexedDb.service';

@Injectable()
export class InstallationFormFilePluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private indexedDb: IndexedDbService
  ) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public updateFormfile(inspectionId: string, pointId: string, pluginId: string, formfile: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, formfile).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  download(inspection: Inspection, pointId: string, pluginId: string, config: any) {
    if (inspection.isOffline && !environment.isManager) {
      const formFile = config.Files.find((f) => f.Value === config.Value);
      this.indexedDb.getImageUrl(formFile.Path).subscribe((res) => {
        window.open(res.changingThisBreaksApplicationSecurity, '_blank');
      });
      return;
    }
    let url = `api/inspections/${inspection.id}/points/${pointId}/installation/formfile/${pluginId}/${config.Value}/download`;
    window.open(url, '_blank');
  }

  private update(inspectionId: string, pointId: string, pluginId: string, formfile: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, formfile).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
